
































































































































import Vue, { PropType } from 'vue';
import CorrectionModel from '../dex-shared/models/CorrectionModel';

export default Vue.extend({
  props: {
    corrections: {
      type: Array as PropType<CorrectionModel[]>,
      required: true,
    },
    width: {
      type: Number,
      required: false,
      default: 400,
    },
  },

  data() {
    return {
      height: 200,
      yAxis: [0, 25, 50, 75, 100],
      xAxisMarginLeft: 0,
      xAxisTextMarginLeft: 70,
      verticalMargin: 100,
      upperMargin: 70,
      barWidth: 8,
      tooltipBox: {
        opacity: 0,
        x: 0,
        y: 5,
        width: 120,
        height: 30,
      },
      tooltipText: {
        opacity: 0,
        x: 0,
        y: 0,
        vHtml: '',
      },
      tooltipDetail: {
        opacity: 0,
        x: 0,
        y: 23,
        width: 20,
        height: 20,
        transform: '',
      },
    };
  },

  methods: {
    prettifyDate(date: Date) {
      return date.toLocaleDateString('pt-br', {
        day: '2-digit',
        month: '2-digit',
        year: '2-digit',
      });
    },
    yAxisY(percentage: number) {
      return (
        this.height -
        ((percentage / 100) * (this.height - this.verticalMargin) +
          (this.verticalMargin - this.upperMargin))
      );
    },
    xAxisX(index: number) {
      const marginLeft = this.xAxisTextMarginLeft;
      return (
        marginLeft +
        index * ((this.width - 2 * marginLeft) / this.corrections.length)
      );
    },
    correctRatio(correction: CorrectionModel) {
      return correction.score / correction.maxScore();
    },
    mouseoverBar(correction: CorrectionModel, correctionIndex: number) {
      this.tooltipBox = {
        ...this.tooltipBox,
        opacity: 1,
        x: this.xAxisX(correctionIndex) - this.tooltipBox.width / 2,
      };

      const tooltipDetailX =
        this.xAxisX(correctionIndex) - this.tooltipDetail.width / 2;

      this.tooltipDetail = {
        ...this.tooltipDetail,
        opacity: 1,
        x: tooltipDetailX,
        transform: `rotate(45, ${tooltipDetailX +
          this.tooltipDetail.width / 2}, ${this.tooltipDetail.y +
          this.tooltipDetail.height / 2})`,
      };

      this.tooltipText = {
        ...this.tooltipText,
        opacity: 1,
        x: this.xAxisX(correctionIndex),
        y: this.tooltipBox.y + this.tooltipBox.height / 2,
        vHtml: `${correction.score} pts`,
      };
    },
    mouseleaveBar() {
      this.tooltipBox = {
        ...this.tooltipBox,
        opacity: 0,
      };

      this.tooltipDetail = {
        ...this.tooltipDetail,
        opacity: 0,
      };

      this.tooltipText = {
        ...this.tooltipText,
        opacity: 0,
      };
    },
  },
});
